module.exports = __webpack_public_path__ + "static/media/bracket-left-top-05.ca8eb9d6.svg";